// import React, { useContext } from 'react'
// import { DContext } from '../../../context/Datacontext'
// import { FaRegEdit } from "react-icons/fa";
// import { MdOutlineDeleteOutline } from "react-icons/md";

// export const StatusType = ({ status, handleUpdate, handleDeleteStatus, formatName }) => {
//     const {currentUser} = useContext(DContext)
//   return (
//                         <div className="md:flex md:justify-center">
//                             <div className="overflow-x-auto bg-white rounded-xl   shadow-md  md:w-[700px]">
//                                 <table className="w-full  text-left border-collapse">
//                                     <thead className="bg-primary-400 text-white">
//                                         <tr>
//                                             <th className="p-3 w-[50px]">S.No</th>
//                                             <th className="p-3 w-[50px]">Group</th>
//                                             <th className="p-3">Status Types</th>
//                                             <th className="p-3">Active</th>
//                                             <th className="p-3">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {status?.length > 0 ? (
//                                             status?.map((s, idx) => (
//                                                 <tr
//                                                     key={s._id}
//                                                     className={`hover:bg-blue-50 transition border-[0.5px] border-slate-100`}
//                                                 >
//                                                     <td className={` p-3 text-center`}>{idx + 1}</td>
//                                                     <td className={` p-3 text-center`}>{s?.group}</td>
//                                                     <td className="p-3  " >
//                                                         <p className={` text-black cursor-pointer font-medium text-lg`}>{formatName(s.status)}</p>
    
//                                                     </td>
//                                                     <td className={`p-3 ${s.isActive ? 'text-green-600' : 'text-gray-500'} `} >
//                                                         {s.isActive ? 'Active' : 'In-Active'}
//                                                     </td>
    
//                                                     <td className="pt-6 flex items-start flex-start gap-3">
//                                                         <FaRegEdit
//                                                             className={`text-lg  text-primary-500 cursor-pointer`}
//                                                             onClick={() => handleUpdate(s._id)} // ✅ only works when active
//                                                         />
    
//                                                         {currentUser.role === 'admin' && (
//                                                             <MdOutlineDeleteOutline
//                                                                 className={`text-lg text-red-500 cursor-pointer`}
//                                                                 onClick={() => handleDeleteStatus(s._id)} // ✅ same logic
//                                                             />
//                                                         )}
    
//                                                         {/* <button
//                                                             disabled={!s.isActive}
//                                                             className={`px-4 py-1 rounded-lg ${!s.isActive
//                                                                     ? 'cursor-not-allowed text-gray-500 bg-gray-300'
//                                                                     : 'bg-secondary-200 text-white hover:bg-secondary-500 cursor-pointer'
//                                                                 }`}
//                                                             onClick={() => s.isActive && handleUpdate(s._id)}  // optional extra safety
//                                                         >
//                                                             Disable
//                                                         </button> */}
    
//                                                     </td>
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <tr>
//                                                 <td className="p-3 text-center text-gray-500" colSpan="7">
//                                                     No Status found.
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//   )
// }











import React, { useContext } from "react";
import { DContext } from "../../../context/Datacontext";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDeleteOutline } from "react-icons/md";

export const StatusType = ({
    status = [],
    handleUpdate,
    handleDeleteStatus,
    formatName,
}) => {
    const { currentUser } = useContext(DContext);

    // Group data
    const groupedStatus = status.reduce((acc, item) => {
        if (!acc[item.group]) {
            acc[item.group] = [];
        }
        acc[item.group].push(item);
        return acc;
    }, {});

    let serialNo = 1;

    return (
        <div className="md:flex md:justify-center">
            <div className="overflow-x-auto bg-white rounded-xl shadow-md md:w-[900px]">
                <table className="w-full border-collapse">
                    <thead className="bg-primary-400 text-white">
                        <tr>
                            <th className="border p-3 w-[70px]">Sl. No</th>
                            <th className="border p-3 w-[220px]">Group</th>
                            <th className="border p-3">Current Status</th>
                            <th className="border p-3 w-[120px]">Active</th>
                            <th className="border p-3 w-[120px]">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.keys(groupedStatus).length > 0 ? (
                            Object.entries(groupedStatus).map(([group, items]) =>
                                items.map((item, index) => (
                                    <tr
                                        key={item._id}
                                        className="hover:bg-blue-50 border"
                                    >
                                        {/* Serial Number */}
                                        <td className="border p-3 text-center">
                                            {serialNo++}
                                        </td>

                                        {/* Group Name only once */}
                                        {index === 0 && (
                                            <td
                                                rowSpan={items.length}
                                                className="border p-3 text-center align-middle font-semibold"
                                            >
                                                {group}
                                            </td>
                                        )}

                                        {/* Status */}
                                        <td className="border p-3">
                                            {formatName(item.status)}
                                        </td>

                                        {/* Active */}
                                        <td
                                            className={`border p-3 text-center ${item.isActive
                                                    ? "text-green-600"
                                                    : "text-red-500"
                                                }`}
                                        >
                                            {item.isActive
                                                ? "Active"
                                                : "Inactive"}
                                        </td>

                                        {/* Actions */}
                                        <td className="border p-3">
                                            <div className="flex justify-center gap-3">
                                                <FaRegEdit
                                                    className="text-primary-500 cursor-pointer"
                                                    onClick={() =>
                                                        handleUpdate(item._id)
                                                    }
                                                />

                                                {currentUser?.role ===
                                                    "admin" && (
                                                        <MdOutlineDeleteOutline
                                                            className="text-red-500 cursor-pointer"
                                                            onClick={() =>
                                                                handleDeleteStatus(
                                                                    item._id
                                                                )
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )
                        ) : (
                            <tr>
                                <td
                                    colSpan="5"
                                    className="text-center p-4 text-gray-500"
                                >
                                    No Status Found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};